export const NAMEBYCATEGORY = {
  '101121': '产后恢复',
  '101123': '孕婴健康',
  '101317': '技能培训',
  '10111112': '抚触推拿',
  '10111114': '抚触推拿'
}

export const CARESSTUINA = ['10111112', '10111114'] //抚触推拿

export const CUSTOMCATEGORYTAGREGLIST: any[] = [
  {
    id: 'c1',
    reg: /101121\d{2}/,
    text: '产后恢复',
    index: 0
  },
  {
    id: 'c2',
    reg: /101123\d{2}/,
    text: '孕婴健康',
    index: 7
  },
  {
    id: 'c3',
    reg: /101317\d{2}/,
    text: '技能培训',
    index: 9
  },
  {
    id: 'c4',
    reg: /101122\d{2}/,
    text: '月嫂',
    index: 2
  },
  {
    id: 'c5',
    reg: /10111112|10111114/,
    text: '抚触推拿',
    index: 4
  }
]


/**
 * 新签月嫂标识
 */
 export const NEW_SIGN_YS_ID = '10112210'